var exports = {
  "Q": "xb99ab02a--0b16a2--link-button",
};

module.exports = exports;
